import { createQueryKeys } from '@lukemorales/query-key-factory';

export const backendValidation = createQueryKeys('backendValidation', {
    orderCreateEnquiry: {
        queryKey: null,
    },
    orderLubesEdit: {
        queryKey: null,
    },
    offerLubes: {
        queryKey: null,
    },
});
